import { GridRowParams } from '@mui/x-data-grid/models/params/gridRowParams';
import { GridActionsCellItem } from '@mui/x-data-grid/components';
import { GridColDef,  } from '@mui/x-data-grid/models/colDef/gridColDef';
import { Delete } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { Member } from '@/api/bol';

interface MemberColumnsProps {
  onDelete: (member: Member) => void;
  canDelete?: boolean;
  deleteTooltip?: string;
}

export const createMemberColumns = ({ onDelete, canDelete = true, deleteTooltip = '' }: MemberColumnsProps): GridColDef[] => [
  {
    field: 'identifier',
    headerName: 'Member Identifier',
    flex: 2,
    minWidth: 250,
    valueGetter: (value: string | undefined, row: Member) => {
      return row.identifier || '-';
    },
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Actions',
    width: 80,
    hideable: false, // Always visible
    getActions: (params: GridRowParams<Member>) => [
      <Tooltip title={!canDelete ? deleteTooltip : ''} key="delete-tooltip">
        <span>
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={() => onDelete(params.row)}
            disabled={!canDelete}
            color="error"
          />
        </span>
      </Tooltip>,
    ],
  },
];